namespace RecordShield.Workspace.Repositories {
    export interface BulkAnalyticsInsertRequest extends Serenity.ServiceResponse {
        Entity?: AnalyticsRow[];
    }
}
